import { z } from 'zod';
import { runStatusSchema, runTriggerSchema } from '../status/run.js';
import { dateRangeQuerySchema, isoDateTimeSchema, objectIdSchema, paginationQuerySchema, sortQuerySchema, } from './common.js';
/**
 * Les deux flux qui produisent des runs (`02` §11, onglet Runs). Le libellé
 * français est celui du vocabulaire arrêté le 10/09/2026 : le fulfillment
 * s'appelle « Suivi Martelet ».
 */
export const RUN_TYPES = ['fulfillment', 'pennylane'];
export const runTypeSchema = z.enum(RUN_TYPES);
export const RUN_TYPE_LABELS = {
    fulfillment: 'Suivi Martelet',
    pennylane: 'Pennylane',
};
/**
 * Segment d'URL du détail d'un run (`/journal/runs/:type/:id`) — en français,
 * comme le reste des chemins.
 */
export const RUN_TYPE_SLUGS = {
    fulfillment: 'suivi-martelet',
    pennylane: 'pennylane',
};
export function runTypeFromSlug(slug) {
    const entry = Object.entries(RUN_TYPE_SLUGS).find(([, value]) => value === slug);
    return entry ? entry[0] : null;
}
/**
 * Ligne unifiée de l'onglet Runs : les deux collections (`fulfillmentRuns`,
 * `pennylaneRuns`) rendues avec les mêmes colonnes. `processed` agrège les
 * compteurs propres à chaque flux (`fulfilled + alreadyFulfilled +
 * stateUpdates` côté Suivi Martelet, `sent` côté Pennylane).
 */
export const runListItemSchema = z.object({
    id: objectIdSchema,
    type: runTypeSchema,
    startedAt: isoDateTimeSchema,
    finishedAt: isoDateTimeSchema.nullable(),
    status: runStatusSchema,
    trigger: runTriggerSchema,
    simulation: z.boolean(),
    processed: z.number().int().min(0),
    errors: z.number().int().min(0),
    error: z.string().nullable(),
});
export const runListQuerySchema = z.object({
    ...paginationQuerySchema.shape,
    ...sortQuerySchema.shape,
    ...dateRangeQuerySchema.shape,
    type: runTypeSchema.optional(),
    status: z.array(runStatusSchema).optional(),
});
//# sourceMappingURL=runs.js.map